import React, { useEffect } from 'react';
import { getQueryString, pexios } from "../../utils/functions";
import { history } from "../../utils/variables";
import {setUser, setToken, firstBoot, setRouterData} from '../../redux/actions';
import { useDispatch } from 'react-redux';
import Modal from "../../components/master/Modal";

export default function ThirdPartyLogin() {
    const dispatch = useDispatch();

    useEffect(() => {
        (async function() {
            const token = await getQueryString('token');
            dispatch(setToken(token));
            const accident_id = await getQueryString('accident_id');
            const report_id = await getQueryString('report_id');
            await pexios('api/v2/get_user')
                .then(res => {
                    dispatch(setUser(res.data));
                });
            dispatch(firstBoot(true));
            if (accident_id) {
                dispatch(setRouterData({id: accident_id, type: 'accident'}));
                history.replace(`/waiting${window.location.search}`);
            }
            else if (report_id) {
                dispatch(setRouterData({id: report_id, type: 'report'}));
                history.replace(`/report-single${window.location.search}`);
            }
            else history.replace('/');
        })();
    }, [dispatch]);
    return (
        <Modal visible={true}>
            <div className='loader-modal'>
                <i className='fas fa-spinner fa-spin'/>
            </div>
        </Modal>
    );
};
